import React from 'react';

export default class Loading extends React.Component {
    render() {
        return (
            <div className="loading-bg">
                <div className="cp-eclipse cp-spinner"></div>
            </div>
        )
    }
}